
import worker from "!!../../node_modules/worker-loader/dist/runtime/inline.js";

export default function Worker_fn() {
  return worker("onmessage=function(e){const{action:t,query:s,dataset:a,keys:o=[]}=e.data;if(\"search\"===t){const e=s?.toLowerCase()?.trim();if(!e)return void postMessage({type:\"result\",filteredData:a});const t=a.filter(t=>o.some(s=>\"string\"===typeof t[s]&&t[s].toLowerCase().includes(e)));postMessage({type:\"result\",filteredData:t})}};\n", "Worker", undefined, undefined);
}
